var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CouponLayout1"},_vm._l((_vm.couponList),function(item,index){return _c('coupon',{key:index,attrs:{"item":item},on:{"receive":_vm.receive}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }